"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Layer = _interopRequireDefault(require("./Layer"));
var _utils = require("../../../../../utils");
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}
/* eslint-disable spaced-comment */
/// <reference path="../../../../../../node_modules/@types/openlayers/index.d.ts" />
/* eslint-enable spaced-comment */

class OpenLayersPolygonLayer extends _Layer.default {
  constructor(layer, polygons) {
    let opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    let id = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
    super(layer, opts, id);
    this._polygons = polygons;
  }
  invalidate() {
    this.createRenderable();
    if (this.map) {
      const map = this.map;
      this.remove();
      this.addTo(map, this._targetIndex);
    }
  }
  createRenderable() {
    const {
      stroke,
      fill
    } = this.opts;
    let id;
    const isMulti = this._polygons.length > 1;
    const polygons = (this._polygons || []).map(polygon => {
      if (!(0, _utils.isset)(id) && (0, _utils.isset)(polygon.id)) {
        id = polygon.id;
      }
      const outer = polygon.outer.map(c => [c.lon, c.lat]);
      const inner = polygon.inner ? polygon.inner.map(p => p.map(c => [c.lon, c.lat])) : [];
      return [outer, ...inner];
    });
    this.source = new ol.source.Vector({
      features: new ol.format.GeoJSON().readFeatures({
        type: 'FeatureCollection',
        features: [{
          type: 'Feature',
          properties: {
            id
          },
          geometry: {
            type: isMulti ? 'MultiPolygon' : 'Polygon',
            coordinates: isMulti ? polygons : polygons[0] || []
          }
        }]
      }, {
        dataProjection: null,
        featureProjection: 'EPSG:3857'
      })
    });
    return new ol.layer.Vector({
      source: this.source,
      style: new ol.style.Style({
        stroke: stroke ? new ol.style.Stroke(stroke) : null,
        fill: fill ? new ol.style.Fill(fill) : null
      })
    });
  }
}
var _default = exports.default = OpenLayersPolygonLayer;
module.exports = exports.default;